export const data = [
    {"imgNum": "1", "title": "현대에버다임","link": "https://www.hyundaieverdigm.com/main/"},
    {"imgNum": "2", "title": "승원건설그룹","link": "http://www.seungwongroup.com/"},
    {"imgNum": "3", "title": "재현하늘창","link": "http://www.jhintex.co.kr/"},
    {"imgNum": "4", "title": "유니센터","link": "http://unicentre.com.au/"},
    {"imgNum": "5", "title": "엘오티베큠","link": "https://www.lotvacuum.com/"},
    {"imgNum": "6", "title": "에코디파이","link": "http://ecodefi.net/#/main"},
    {"imgNum": "7", "title": "클럽 ES리조트","link": "https://www.clubes.co.kr/"},
    {"imgNum": "8", "title": "대한병원코디네이터협회","link": "http://www.khca.or.kr/main/"},
    {"imgNum": "9", "title": "미카도스시","link": "http://www.mikadosushi.co.kr/"},
    {"imgNum": "33", "title": "삼우에레코","link": "http://www.samwooeleco.com/#section1"},
    {"imgNum": "10", "title": "세양물산","link": "http://seyangsports.com/"},
    {"imgNum": "11", "title": "KG GNS","link": "http://kggns.co.kr/"},
    {"imgNum": "12", "title": "티제이씨라이프","link": "http://rxtem.co.kr/"},
    {"imgNum": "13", "title": "다온한약국","link": "http://daon-herb.com/"},
    {"imgNum": "14", "title": "SWM","link": "https://swm.ai/"},
    {"imgNum": "15", "title": "SJ솔루션","link": "http://sjsol.co.kr/"},
    {"imgNum": "16", "title": "유원디스플레이","link": "http://uonedp.com/"},
    {"imgNum": "17", "title": "TNS","link": "http://tnsind.co.kr/"},
    {"imgNum": "18", "title": "1인가구 생활 헬스케어 사업","link": "http://lifehealthcare.kr/"},
    {"imgNum": "19", "title": "파인트리","link": "http://www.pinetree.sg/"},
    {"imgNum": "20", "title": "원주웨딩타운","link": "http://www.wjwedding.co.kr/"},
    {"imgNum": "21", "title": "킨스파트너스","link": "http://kinspartners.kr/"},
    {"imgNum": "22", "title": "동국","link": "http://dkglp.com/"},
    {"imgNum": "23", "title": "광동옥수수수염차","link": "http://kwangdong.iceserver.co.kr/"},
    {"imgNum": "24", "title": "디엠엔지니어링","link": "http://dm-eng.com/"},
    {"imgNum": "25", "title": "베르티스마스토체크","link": "http://mastocheck.com"},
    {"imgNum": "26", "title": "서강전문학교","link": "http://apply.sg.ac.kr/"},
    {"imgNum": "27", "title": "아구공","link": "http://agu0.com/"},
    {"imgNum": "28", "title": "유학앤교육","link": "http://uhak.iceserver.co.kr"},
    {"imgNum": "29", "title": "Stagnant Stone","link": "http://stagnantstone.com/"},
    {"imgNum": "30", "title": "라스칼코리아","link": "http://las-korea.com/main/"},
    {"imgNum": "31", "title": "아산갤러리","link": "http://www.asangallery.co.kr/new/"},
    {"imgNum": "32", "title": "한국직업전문학교","link": "http://www.koreait.ac.kr/new2/main/"},
    
]